export default __webpack_public_path__ + "static/media/uploader-dexcom-4.13d44d13.png";